import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { _ButtonAPI } from "..";

const useStyles = makeStyles(({ palette }: Theme) => ({
    tab: {
        borderBottom: `1px solid ${palette.grey[400]}`
    }
}));

interface ITabbedFormFormProps {
    TabLabels: string[];
    Actions: React.ReactNodeArray;
    RenderTabContent: (index: number) => React.ReactNode;
}

export const _TabbedForm: React.FC<ITabbedFormFormProps> = ({ Actions, TabLabels, RenderTabContent }) => {
    const classes = useStyles();
    const [activeTab, setActiveTab] = React.useState(0);

    const onTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Card>
            <CardContent>
                <TabContext value={activeTab.toString()}>
                    <TabList value={activeTab} onChange={onTabChange} textColor="secondary" indicatorColor="secondary" aria-label="companies tabs">
                        {TabLabels.map((label, index) => (
                            <Tab value={index.toString()} label={label} key={index} className={classes.tab} />
                        ))}
                    </TabList>
                    <TabPanel value={activeTab.toString()}>{RenderTabContent(activeTab)}</TabPanel>
                </TabContext>
            </CardContent>
            <CardActions disableSpacing>
                <Grid container item spacing={3} xs={12} justify="flex-end">
                    {Actions.map((action, index) => (
                        <Grid item key={index}>
                            {action}
                        </Grid>
                    ))}
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/TabbedForm.tsx